function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-22.352 -21.15)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m56.4 48.7c-2 1.8-4.3 3.6-6.6 5-1.5 1-2.9 1.8-4.4 3-1.1 0.9-2 1.8-3.2 2.7-2.7 2.6-5.2 5.6-6.9 8.8-2.2 4-3.9 8.4-4.2 13.1 0 0.2 0.1 0.4-0.1 0.5 0.3 0.2 0.3 0.2 0.5 0.3 11.2 6.6 28-1.2 37.7-17.2 8.2-14 8.5-29.5 1.3-37.9-1.2 4.5-3.2 8.7-5.8 12.6-2.2 3.3-5.1 6.4-8.3 9.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m27.6 78.8c1.2-4.5 3.1-8.9 5.6-12.7 2.1-3.3 4.5-6.5 7.2-9.3 1.6-1.7 3.2-3.4 5.1-4.7 1.1-0.9 2.3-1.4 3.5-2.3 2.5-1.7 5-3.5 7.3-5.8 2.9-2.6 5.5-5.9 7.4-9.4 0.9-1.8 1.7-3.5 2.3-5.6 0.2-0.9 0.5-1.9 0.7-3 0.1-0.5 0.2-1.1 0.1-1.6 0 0 0.1-0.5 0.1-0.7l-0.3-0.2c-11.2-6.6-28 1.2-37.7 17.2-8.5 14-8.5 29.7-1.3 38.1z"
}));

var SvgCoffeeBean = function SvgCoffeeBean(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53.288,
    height: 63.299,
    fill: "#000000",
    viewBox: "0 0 53.288 63.299",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoffeeBean, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CoffeeBean.7e5e05e9.svg";
export { ForwardRef as ReactComponent };